import React, { useState } from "react";
import Chart from "react-apexcharts";
import { dashboardChartProps } from "../../core/dto/dashboard.dto";
import { PieBarChart } from "./PieBarChart";

const AgentWiseTotalCallsChart: React.FC<dashboardChartProps> = ({ apiEndpoint, startDate, endDate, selectedCallType, onChartLoaded }) => {

    const [completedOrMissedCall, setCompletedOrMissedCall] = useState("completed_calls");
    const chartData = PieBarChart({
        apiEndpoint, startDate, endDate, labelKey: "agent_name", valueKey: "calls_count", onChartLoaded,
        payloadExtra: { completedOrMissedCall, call_type: selectedCallType, onChartLoaded , chartName:"AgentTotalCall"}
    });

    return (
        <div className="overflow-hidden">
            <div className="row mb-3 chart-header" style={{ borderBottom: "2px solid #ddd", paddingBottom: "10px", background: "gray" }}>
                <div className="col-12"><h5 className="text-center">Agent Total Calls</h5></div>
            </div>

            <div className="p-3 d-flex align-items-center gap-5">
                <div><label style={{ minWidth: "80px", margin: 0 }}>Call Type</label></div>
                <select
                    className="form-select pe-5"
                    value={completedOrMissedCall}
                    style={{ width: "300px" }}
                    onChange={(e) => setCompletedOrMissedCall(e.target.value)}
                >
                    <option value="completed_calls">Completed Calls</option>
                    <option value="missed_calls">Missed Calls</option>
                </select>
            </div>

            <div className="col-12">
                {chartData && chartData.count > 0 ? (
                    <Chart options={chartData.labels} series={chartData.series} type="bar" height={380} />
                ) : (
                    <div className="text-center py-4">No Records Found</div>
                )}
            </div>
        </div>
    );
};

export default AgentWiseTotalCallsChart;
